"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//
const CustomIcons_1 = require("./CustomIcons");
// ----------------------------------------------------------------------
function Select(theme) {
    return {
        MuiSelect: {
            defaultProps: {
                IconComponent: CustomIcons_1.InputSelectIcon,
            },
        },
    };
}
exports.default = Select;
